import React from "react";
import { NutriValues } from "../../data/nutriValues";
import { MacroBar } from "./MacroBar";

export function NutriRow({ nutri }: { nutri: NutriValues }) {
  if (!nutri.kcal || nutri.kcal <= 0) return null;
  return (
    <MacroBar
      fat={nutri.fat}
      carbs={nutri.carbs}
      protein={nutri.protein}
      kcal={nutri.kcal}
      showLabels
    />
  );
}
